import { Box, Button, Dropdown, Space } from '@/components';
import { useWorkflowStackSiderView } from '@/features/workflow/hooks/stack-sider-view';
import { DownOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';

export const WorkflowSiderListHeader: FC = () => {
  const { t } = useTranslation();
  const stackSiderView = useWorkflowStackSiderView();

  const siderConfig = stackSiderView.lastItem?.config;

  invariant(siderConfig, t('unreachable-code'));

  return (
    <Space>
      <Box>
        <Dropdown
          menu={{
            items: [
              {
                key: 'workflow-form',
                label: t('create'),
              },
              {
                key: 'create-from-template',
                label: t('workflow.create-workflow-from-template'),
              },
            ].filter(Boolean),
            onClick: (e) => {
              switch (e.key) {
                case 'workflow-form':
                  stackSiderView.push({
                    payload: {
                      config: {
                        viewType: 'workflow-form',
                        isEditing: false,
                        target: siderConfig.target,
                      },
                    },
                    target: stackSiderView.target,
                  });
                  break;
                case 'create-from-template':
                  stackSiderView.push({
                    payload: {
                      config: {
                        viewType: 'create-from-template',
                        target: siderConfig.target,
                      },
                    },
                    target: stackSiderView.target,
                  });
                  break;
                default:
              }
            },
          }}
        >
          <Button type="primary">
            <Space>
              {t('create')}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Box>
    </Space>
  );
};
